;(function($, undefined) {
	// NCA GAM - remove hidden ads and other elements
	$(document).ready(function() {
		var isSub = typeof isSubscriber === 'function' ? isSubscriber() : false
		var userAgent = navigator.userAgent.toLowerCase()
		var isTablet = /(ipad|tablet|(android(?!.*mobile))|(windows(?!.*phone)(.*touch))|kindle|playbook|silk|(puffin(?!.*(IP|AP|WP))))/.test(userAgent)
		var isMobile = document.body.clientWidth <= 736 ? true : false

		// Base selector based on mobile or desktop view
		var selector = isMobile
			? '.ad-block.ad-mrec, .ad-block.ad-leader, .ad-block.ad-halfpage, .desktop-ad'
			: '.ad-block.ad-m-banner, .ad-block.ad-m-mrec, .mobile-ad'

		// Pick which sidebar to remove
		selector =
			isSub === true
				? '.sidebar-1:not(.subscriber-sidebar)'
				: '.sidebar-1.subscriber-sidebar'
		// Remove hidden ads in the article view for subscribers
		if (isSub && $('body').hasClass('newsEntryBody')) {
			selector += ',.top .hero .sitebanner, .after_story_full_width_fragment, .genericBillboard'
			// Remove unruly for subscribers
			selector += ', .ad-block.ad-custom.ad-unruly'
		}
		// Remove Billboards on tablet
		if (isTablet) {
			selector += ',.ad-block.ad-billboard'
		}

		console.info('GAM selector', selector)
		// Execute remove
		$(selector).remove()
	})
})(jQuery);
